<template>
  <div id="login" class="mt-5 p-5">
    <v-container>
      <div class="login-section" v-if="!userIsResettingPassword">
        <div class="headline mb-4">Log In</div>
        <v-card outlined>
          <v-card-text>
            <v-form novalidate @submit.prevent="login">
              <v-list-item-group v-if="errors.length" class="mb-4">
                <v-alert dense text type="error">
                  <p v-for="(error, i) in errors" :key="i" class="mb-0">
                    {{ error }}
                  </p>
                </v-alert>
              </v-list-item-group>

              <div class="grey-text mt-5">
                <v-text-field
                  v-model="email"
                  label="Email"
                  prepend-icon="mail"
                  type="email"
                  required
                  outlined
                ></v-text-field>
                <v-text-field
                  v-model="password"
                  label="Password"
                  prepend-icon="lock"
                  type="password"
                  required
                  outlined
                ></v-text-field>
              </div>
              <div class="text-center">
                <v-btn type="submit" color="primary" depressed>Log In</v-btn>
              </div>
            </v-form>
            <div class="text-center">
              <v-divider class="my-4"></v-divider>
              <p class="mb-0">
                <a @click="userIsResettingPassword = true">Forgot Password?</a>
              </p>
              <p class="mb-0">
                <span>Don't have an account yet? </span>
                <router-link to="register">Sign Up</router-link>
              </p>
            </div>
          </v-card-text>
        </v-card>
      </div>
      <div class="forgot-password-section" v-else>
        <div class="headline mb-4">Forgot Password</div>
        <v-card outlined xs6>
          <v-card-text class="mt-5">
            <v-list-item-group v-if="recoveryErrors.length" class="mb-4">
              <v-alert dense text type="error">
                <p v-for="(error, i) in recoveryErrors" :key="i" class="mb-0">
                  {{ error }}
                </p>
              </v-alert>
            </v-list-item-group>
            <v-text-field
              v-model="recoveryEmail"
              label="Email"
              prepend-icon="mail"
              type="email"
              outlined
              required
            ></v-text-field>
            <div class="text-center">
              <v-divider class="my-4"></v-divider>
              <v-btn color="error" depressed @click="resetPassword">Reset Password</v-btn>
              <p class="mt-2 mb-0">
                <a @click="userIsResettingPassword = false">Back to login</a>
              </p>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </v-container>
  </div>
</template>

<script>
import validate from '@/modules/validation-module';

export default {
  name: 'login',
  data() {
    return {
      errors: [],
      email: null,
      password: null,
      recoveryEmail: null,
      userIsResettingPassword: false,
      recoveryErrors: [],
    };
  },
  methods: {
    login() {
      this.errors = [];
      if (!validate.email(this.email)) {
        this.errors.push('Please enter a valid email address');
      }
      if (!this.errors.length) {
        this.$firebase.auth().signInWithEmailAndPassword(this.email, this.password)
          .then((response) => {
            const user = response.user;
            this.$store.dispatch('fetchUser', { user })
            this.$router.push({
              name: 'home',
            });
          })
          .catch(err => this.errors.push(err.message));
      }
    },
    resetPassword() {
      this.recoveryErrors = [];
      this.$firebase.auth().sendPasswordResetEmail(this.recoveryEmail)
        .then(() => {
          this.$noty.success(`Success! A password reset email has been sent to ${this.recoveryEmail}`);
          this.recoveryErrors = null;
          this.userIsResettingPassword = false;
        })
        .catch(error => this.recoveryErrors.push(error.message));
    },
  },
};
</script>